import { FeatureFlagEnum, FeatureFlagsInterface } from "@finway-group/shared/lib/models"

export const hasFeatureFlags = (featureFlags: FeatureFlagsInterface | undefined, requiredFlags: FeatureFlagEnum[]) => {
    if(!featureFlags) return false
    for (const requiredFlag of requiredFlags) if (!featureFlags[requiredFlag]) return false
    return true
}